export const COMPANYMEMOLIST_SEARCH = 'COMPANYMEMOLIST_SEARCH'
export const COMPANYMEMOLIST_PAGE = 'COMPANYMEMOLIST_PAGE'